module.exports = __webpack_public_path__ + "img/facebook-dialog.3e250c82.svg";